/**
 * Utility functions for payment calculation
 * Pure functions — no React, no state
 */

const sum = (list = []) => list.reduce((a, b) => a + b, 0);

const getSelectedSlots = (slots = []) =>
    slots.filter(slot => slot.isSelected);

export const calculateTotal = (slots = []) => {
    const selectedSlots = getSelectedSlots(slots);

    const totalSlotCharges = sum(
        selectedSlots.map(
            slot => slot.paymentBreakdown?.basePrice ?? 0
        )
    );

    const totalGST = sum(
        selectedSlots.map(slot =>
            (slot.paymentBreakdown?.GST ?? 0) +
            (slot.paymentBreakdown?.platformGST ?? 0) +
            (slot.paymentBreakdown?.gatewayFeeGST ?? 0)
        )
    );

    const totalServiceFee = sum(
        selectedSlots.map(slot =>
            (slot.paymentBreakdown?.platformFee ?? 0) +
            (slot.paymentBreakdown?.gatewayFee ?? 0)
        )
    );

    return totalSlotCharges + totalGST + totalServiceFee;
};

export const calculateDifference = (
    slots,
    newSlots,
    oldSlots
) => {
    return calculateTotal(newSlots) - calculateTotal(oldSlots);
};

export const getTotalCountData = (slots) => {
    let totalBasePrice = 0;
    let gst = 0;
    let totalPlatformgst = 0;
    let totalGatwayFee = 0;
    let totalGatewayFeegst = 0;
    let totalPlatformFee = 0;

    slots
        .forEach(slot => {
            totalBasePrice += slot.basePrice ?? 0;
            gst += slot.GST ?? 0;
            totalPlatformgst += slot.platformGST ?? 0;
            totalGatwayFee += slot.gatewayFee ?? 0;
            totalGatewayFeegst += slot.gatewayFeegst ?? 0;
            totalPlatformFee += slot.platformFee ?? 0;
        });

    // Round each value to 2 decimal places
    totalBasePrice = parseFloat(totalBasePrice.toFixed(2));
    gst = parseFloat(gst.toFixed(2));
    totalPlatformgst = parseFloat(totalPlatformgst.toFixed(2));
    totalGatwayFee = parseFloat(totalGatwayFee.toFixed(2));
    totalGatewayFeegst = parseFloat(totalGatewayFeegst.toFixed(2));
    totalPlatformFee = parseFloat(totalPlatformFee.toFixed(2));

    const totalGst =
        gst +
        totalPlatformgst +
        totalGatewayFeegst;

    const serviceFee =
        totalPlatformFee +
        totalGatwayFee;

    const total = totalBasePrice + totalGst + serviceFee;

    // Return the rounded totals in the totalCounts object
    const totalCounts = {
        basePrice: totalBasePrice,
        gst: gst,
        platformgst: totalPlatformgst,
        gatewayFeegst: totalGatewayFeegst,
        platformFee: totalPlatformFee,
        gatewayFee: totalGatwayFee,
        totalGst: totalGst,
        serviceFee: serviceFee,
        total: total
    };

    return totalCounts;
}